import { CommonModule } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { Modules } from '@urls';

@Component({
  selector: 'core-avatar',
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent {
  public characters!: string;
  basePath = 'assets/images/file/';
  defaultAvatar = `assets/images/auth/logo.png`;
  isImageView: boolean = false;
  storageUrl = `${Modules.Store}`;
  avatarUrl = '';

  @Input() set Avatar(data: string) {
    if (!data) { this.characters = ''; return; }
    const words = data.trim().split(/\s+/);
    if (words.length === 1) {
      this.characters = words[0].substring(0, 2).toUpperCase();
    } else {
      this.characters = (words[0][0] + words[1][0]).toUpperCase();
    }
  }

  @Input() set Image(data: string) {
    this.isImageView = true;
    if (data) { this.avatarUrl = `${this.storageUrl}/image/${data}`; } else { this.avatarUrl = this.defaultAvatar; }
  }

  @Input() CSSClass: string = '';

  public randomColor: string = '';
  public fontColor: string = '';

  constructor() {
    this.randomColor = this.generateColorFromTime();
    this.fontColor = this.getContrastColor(this.randomColor);
  }

  errorLoadImage() { this.avatarUrl = this.defaultAvatar; }

  private generateColorFromTime(): string {
    const now = Date.now();
    const hex = ((now & 0xffffff) | 0x1000000).toString(16).slice(1, 7);
    return `#${hex}`;
  }

  private getContrastColor(hexColor: string): string {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 2), 16);
    const b = parseInt(hex.substring(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }
}
